module.exports = __webpack_public_path__ + "static/TM1-Politica-de-Cookies-Site-71e157f8924fb6c3ad7cf3773188a977.pdf";